var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("BasePageLayout", [
    _c("div", { attrs: { slot: "page__title" }, slot: "page__title" }, [
      _vm._v(
        " " +
          _vm._s(
            _vm.$vuetify.lang.t(
              "$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.TITLE"
            )
          ) +
          " "
      ),
    ]),
    _c(
      "div",
      { staticClass: "pa-8" },
      [
        _c(
          "v-row",
          { staticClass: "mb-4" },
          [
            _c(
              "v-col",
              {
                staticClass: "d-flex flex-column align-item-center",
                attrs: { cols: "6" },
              },
              [
                _c(
                  "v-card",
                  { staticClass: "pa-4 full-width", attrs: { outlined: "" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "subtitle-1 font-weight-bold text--secondary mb-4",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$vuetify.lang.t(
                                "$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.LABEL_COURSE_QUANTITY_SOLD_IN_SIX_MONTH"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "caption text-right" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t(
                              "$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.LABEL_TOTAL_BILL"
                            )
                          ) +
                          " "
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "mb-4 text-right font-weight-bold",
                        staticStyle: { color: "#ff1d30" },
                      },
                      [_vm._v(" " + _vm._s(_vm.totalBill) + " ")]
                    ),
                    _c("GraphStatistic", {
                      staticClass: "bg-white pt-0 rounded",
                      staticStyle: { height: "176px" },
                      attrs: { dataForChart: _vm.graphData, type: "quantity" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "v-col",
              {
                staticClass: "d-flex flex-column align-item-center",
                attrs: { cols: "6" },
              },
              [
                _c(
                  "v-card",
                  { staticClass: "pa-4 full-width", attrs: { outlined: "" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "subtitle-1 font-weight-bold text--secondary mb-4",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$vuetify.lang.t(
                                "$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.LABEL_REVENUE_IN_SIX_MONTH"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "caption text-right" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t(
                              "$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.LABEL_TOTAL_REVENUE"
                            )
                          ) +
                          " "
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "mb-4 text-right font-weight-bold",
                        staticStyle: { color: "#2e4493" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              Number(
                                _vm.totalRevenue.toFixed(0)
                              ).toLocaleString()
                            ) +
                            " " +
                            _vm._s(
                              _vm.$vuetify.lang.t(
                                "$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.LABEL_CURRENCY_UNIT"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c("GraphStatistic", {
                      staticClass: "bg-white pt-0 rounded",
                      staticStyle: { height: "176px" },
                      attrs: { dataForChart: _vm.graphData, type: "price" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "v-card",
          {
            staticClass: "px-4 py-2 mb-10",
            attrs: { outlined: "", color: "grey lighten-4" },
          },
          [
            _c("div", { staticClass: "caption text--disabled text-center" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$vuetify.lang.t(
                      "$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.LABEL_STATISTICS_WITH_SUCCESSFUL_ORDERS"
                    )
                  ) +
                  " "
              ),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "d-flex justify-space-between align-center mb-4" },
          [
            _c("div", { staticClass: "text-h6 font-weight-medium" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$vuetify.lang.t(
                      "$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.TITLE_STATISTIC"
                    )
                  ) +
                  " "
              ),
            ]),
            _c("MonthPicker", {
              attrs: { disabled: _vm.loading },
              on: { change: (value) => _vm.onChangeMonth(value) },
            }),
          ],
          1
        ),
        _c("NumberStatistic", {
          staticClass: "mb-5",
          attrs: {
            totalBillsInMonth: _vm.reportResult.count,
            income: _vm.reportResult.totalPrice,
          },
        }),
        _c("TableStatistic", {
          attrs: {
            loading: _vm.loading,
            items: _vm.statistic,
            count: _vm.countTotal,
          },
          on: { onPageChange: _vm.onPageChange },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }